import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBar } from '@angular/material/progress-bar'
import { TaxDocumentTypeService } from '../../../core/services/tax-document/tax-document-type/tax-document-type.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { TaxDocumentClientEditFormComponent } from './tax-document-client-form/tax-document-client-edit-form.component'
import { ContactClientEditFormComponent } from '../../contact/contact-client-edit/contact-client-form/contact-client-edit-form.component'

@Component({
  selector: 'tax-document-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    TaxDocumentClientEditFormComponent,
    ContactClientEditFormComponent,
  ],
  templateUrl: './tax-document-client-edit.component.html',
  styleUrl: './tax-document-client-edit.component.scss',
  providers: [TaxDocumentTypeService],
  standalone: true,
})
export class TaxDocumentClientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private taxDocumentTypeService: TaxDocumentTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading: boolean = true

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() idPerson: number = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'taxDocumentType',
      key: 'tipoDocFiscalDescricao',
      description: 'Tipo documento',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: true },
      description: 'Ações',
    },
  ]

  page: number = 1
  rows: number = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['taxDocumentType', 'action']

  ngOnInit(): void {
    this.getTaxDocumentByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList() {
    this.getTaxDocumentByPerson()
  }

  getTaxDocumentByPerson() {
    this.loading = true
    this.taxDocumentTypeService
      .listPagedTaxDocumentByPerson(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.taxDocumentTypeService
      .deleteTaxDocument({ id: element.id })
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.uploadList()
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.success(err.message)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  clearItem() {
    this.item = {}
  }
}
